// React Dependencies
import React, { useState, useEffect } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

// Internal Dependencies
import FoodReviewORGenericHighlight from './foodReviewORGeneric';
import apiService from '../../../services.js/apiService';

const GenericHighlight = ({ match }) => {
  const pageId = match.params.id;
  const [pageData, setPageData] = useState(null);

  const getPageDataHandler = async () => {
    try {
      const data = await apiService.getPageById(pageId);
      setPageData(data);
    } catch (err) {
      toast.error('Error getting page data, please report to IT team.');
      console.log('error in getPageDataHandler: ', err);
    }
  };

  useEffect(() => {
    getPageDataHandler();
  }, []);

  return (
    <FoodReviewORGenericHighlight
      pageId={pageId}
      pageName={pageData && pageData.name}
      heading="Generic"
      isGeneric
    />
  );
};

export default GenericHighlight;

GenericHighlight.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};
